export default "__VITE_ASSET__6d9139b5__"